<template>
  <div class="home">
    <van-form>
      <p class="home-perspmal-boundary"></p>
      <div class="home-perspmal-van-cell">
        <div class="home-perspmal-van-cell__title">
          <span>客户服务主体类型</span>
        </div>
        <div class="home-perspmal-van-cell__value home-perspmal-van-cell__values">
          <van-radio-group v-model="gather.merchant_business_type" direction="horizontal">
            <van-radio name="1">企业</van-radio>
            <van-radio name="2" style="margin:0;">个体商户</van-radio>
            <van-radio name="3" style="margin:0;">小微商户</van-radio>
          </van-radio-group>
        </div>
      </div>
      <p class="home-perspmal-boundary"></p>
      <div class="home-perspmal-van-cell">
        <div class="home-perspmal-van-cell__title">
          <span>财户类型</span>
        </div>
        <div class="home-perspmal-van-cell__value">
          <van-radio-group v-model="gather.account_type" direction="horizontal">
            <van-radio name="1">对公</van-radio>
            <van-radio name="2">对私</van-radio>
          </van-radio-group>
        </div>
      </div>
      <p class="home-perspmal-boundary"></p>
      <div class="home-perspmal-van-cell">
        <div class="home-perspmal-van-cell__title">
          <span>结算类型</span>
        </div>
        <div class="home-perspmal-van-cell__value">
          <van-radio-group v-model="gather.settlement_type" direction="horizontal">
            <van-radio name="1">法人结算</van-radio>
            <van-radio name="2">非法人结算</van-radio>
          </van-radio-group>
        </div>
      </div>
      <p class="home-perspmal-boundary"></p>
      <div class="home-perspmal-van-cell">
        <div class="home-perspmal-van-cell__title">
          <span>营业证件类型</span>
        </div>
        <div class="home-perspmal-van-cell__value home-perspmal-van-cell__values">
          <van-radio-group v-model="gather.license_type" direction="horizontal">
            <van-radio name="0">营业执照</van-radio>
            <van-radio name="1" style="margin:0;">三证合一</van-radio>
            <van-radio name="2" style="margin:0;">手持身份证</van-radio>
          </van-radio-group>
        </div>
      </div>
      <p class="home-perspmal-boundary"></p>
      <div class="home-perspmal-van-cell">
        <div class="home-perspmal-van-cell__title">
          <span>营业证件号码</span>
        </div>
        <div class="home-perspmal-van-cell__value">
          <van-field
            required
            v-model="gather.license_no"
            input-align="right"
            placeholder="请输入证件号码"
          />
        </div>
      </div>
      <p class="home-perspmal-boundary"></p>
      <div class="home-perspmal-van-cell">
        <div class="home-perspmal-van-cell__title">
          <span>营业证件到期日</span>
        </div>
        <div class="home-perspmal-van-cell__value">
          <span class="home-van-dar-time" @click="show = true">{{gather.license_expire}}</span>
          <van-calendar
            v-model="show"
            @confirm="onConfirm"
            color="#0065F0"
            :min-date="minDate"
            :max-date="maxDate"
          />
        </div>
      </div>
      <p class="home-perspmal-boundary"></p>
      <div class="home-perspmal-van-cell">
        <div class="home-perspmal-van-cell__title">
          <span>法人姓名</span>
        </div>
        <div class="home-perspmal-van-cell__value">
          <van-field required v-model="gather.artif_nm" input-align="right" placeholder="请输入法人姓名" />
        </div>
      </div>
      <p class="home-perspmal-boundary"></p>
      <div class="home-perspmal-van-cell">
        <div class="home-perspmal-van-cell__title">
          <span>法人身份证</span>
        </div>
        <div class="home-perspmal-van-cell__value">
          <van-field
            required
            v-model="gather.legalIdnum"
            input-align="right"
            placeholder="请输入法人身份证"
          />
        </div>
      </div>
      <p class="home-perspmal-boundary"></p>
      <div class="home-perspmal-van-cell">
        <div class="home-perspmal-van-cell__title">
          <span>身份证有效期</span>
        </div>
        <div class="home-perspmal-van-cell__value home-perspmal-van-cell__val">
          <span class="home-van-dar-time" @click="showse = true">{{gather.legalIdnumExpire}}</span>
          <van-calendar
            v-model="showse"
            @confirm="onConfirma"
            color="#0065F0"
            :min-date="minDate"
            :max-date="maxDate"
          />
        </div>
      </div>
      <p class="home-perspmal-boundary"></p>
      <div class="home-perspmal-van-cell">
        <div class="home-perspmal-van-cell__title">
          <span>结算人身份证号码</span>
        </div>
        <div class="home-perspmal-van-cell__value">
          <van-field
            required
            v-model="gather.merchant_id_no"
            input-align="right"
            placeholder="请输入证件号码"
          />
        </div>
      </div>
      <p class="home-perspmal-boundary"></p>
      <div class="home-perspmal-van-cell">
        <div class="home-perspmal-van-cell__title">
          <span>结算人身份证有效期</span>
        </div>
        <div class="home-perspmal-van-cell__value home-perspmal-van-cell__val">
          <span class="home-van-dar-time" @click="showses = true">{{gather.merchant_id_expire}}</span>
          <van-calendar
            v-model="showses"
            @confirm="onConfirmas"
            color="#0065F0"
            :min-date="minDate"
            :max-date="maxDate"
          />
        </div>
      </div>
      <p class="home-perspmal-boundary"></p>
      <div class="home-perspmal-van-cell">
        <div class="home-perspmal-van-cell__title">
          <span>入账银行开户号</span>
        </div>
        <div class="home-perspmal-van-cell__value">
          <van-field
            required
            v-model="gather.account_name"
            input-align="right"
            placeholder="请输入入账银行开户号"
          />
        </div>
      </div>
      <p class="home-perspmal-boundary"></p>
      <div class="home-perspmal-van-cell">
        <div class="home-perspmal-van-cell__title">
          <span>入账银行开户卡号</span>
        </div>
        <div class="home-perspmal-van-cell__value">
          <van-field
            required
            v-model="gather.account_no"
            input-align="right"
            placeholder="请输入入账银行开户卡号"
          />
        </div>
      </div>
      <p class="home-perspmal-boundary"></p>
      <div class="home-perspmal-van-cell">
        <div class="home-perspmal-van-cell__title">
          <span>入账银行预留手机号</span>
        </div>
        <div class="home-perspmal-van-cell__value">
          <van-field
            required
            v-model="gather.account_phone"
            input-align="right"
            placeholder="请输入入账银行预留手机号"
          />
        </div>
      </div>
      <p class="home-perspmal-boundary"></p>
      <div class="home-perspmal-van-cell">
        <div class="home-perspmal-van-cell__title">
          <span>入账银行卡开户支行</span>
        </div>
        <div class="home-perspmal-van-cell__value home-perspmal-van-cell__val">
          <span class="home-van-dar-time" @click="showsesr= true">{{gather.bank_name}}</span>
          <van-calendar
            v-model="showsesr"
            @confirm="onConfirmasr"
            color="#0065F0"
            :min-date="minDate"
            :max-date="maxDate"
          />
        </div>
      </div>
      <p class="home-perspmal-boundary"></p>
      <div class="home-perspmal-van-cell">
        <div class="home-perspmal-van-cell__title">
          <span>清算类型</span>
        </div>
        <div class="home-perspmal-van-cell__value">
          <van-radio-group v-model="gather.settle_type" direction="horizontal">
            <van-radio name="1">自动结算</van-radio>
            <van-radio name="2">手动结算</van-radio>
          </van-radio-group>
        </div>
      </div>
      <p class="home-perspmal-boundary"></p>
      <uploadImg class="uploader-business" label="营业执照" @business="business"></uploadImg>
      <p class="home-perspmal-boundary"></p>
      <van-field class="uploader-identity" name="uploader" identity label="法人身份证正反面">
        <template #input>
          <upload @identityZ="identityZ"></upload>
          <upload @identityY="identityY"></upload>
        </template>
      </van-field>
      <p class="home-perspmal-boundary"></p>
      <van-field class="uploader-bankCard" name="uploader" identity label="入账银行卡正反面照片">
        <template #input>
          <upload @img_bankcard_a="img_bankcard_a"></upload>
          <upload @img_bankcard_b="img_bankcard_b"></upload>
        </template>
      </van-field>
      <p class="home-perspmal-boundary"></p>
      <uploader class="home-pmal-Photo" label="商户门头照片" @img_logo="img_logo"></uploader>
      <p class="home-perspmal-boundary"></p>
      <uploader class="home-pmal-Photo" label="门脸(内设)照片(前台)" @img_indoor="img_indoor"></uploader>
      <p class="home-perspmal-boundary"></p>
      <uploader class="home-pmal-Photo" label="店内环境照片" @img_contract="img_contract"></uploader>
      <p class="home-perspmal-boundary"></p>
      <uploader class="home-pmal-Photo" label="其他证明材料" @img_other="img_other"></uploader>
      <p class="home-perspmal-boundary"></p>
      <uploader class="home-pmal-Photo" label="本人手持身份证照片" @img_idcard_holding="img_idcard_holding"></uploader>
      <p class="home-perspmal-boundary"></p>
      <uploader class="home-pmal-Photo" label="开户许可证照片" @img_open_permits="img_open_permits"></uploader>
      <p class="home-perspmal-boundary"></p>
      <uploader class="home-pmal-Photo" label="组织机构代码证照片" @img_org_code="img_org_code"></uploader>
      <p class="home-perspmal-boundary"></p>
      <uploader class="home-pmal-Photo" label="税务登记证照片" @img_tax_reg="img_tax_reg"></uploader>
      <p class="home-perspmal-boundary"></p>
      <uploader class="home-pmal-Photo" label="入账非法人证明照片" @img_unincorporated="img_unincorporated"></uploader>
      <p class="home-perspmal-boundary"></p>
      <van-field class="uploader-identity" name="uploader" identity label="对私账户身份证正反面照片">
        <template #input>
          <upload @img_private_idcard_a="img_private_idcard_a"></upload>
          <upload @img_private_idcard_b="img_private_idcard_b"></upload>
        </template>
      </van-field>
    </van-form>

    <div class="home-cell__value-buttom">
      <Debounce :time="300" isDebounce>
        <van-button @click="nextstep " round type="primary">提交</van-button>
      </Debounce>
    </div>
  </div>
</template>
<script>
// <!-- class="home-perspmal-MerchantEntrancePhoto" -->
import uploadImg from "../../components/uploadImg";
import upload from "../../components/upload";
import uploader from "../../components/uploader";
import areaList from "@/config/area";
import { Toast } from "vant";
// import moment from "moment";
// import getUpToken from "@/api/getUpToken";
// import axios from "axios";
export default {
  name: "merchantsSettlement",
  components: {
    uploadImg,
    upload,
    uploader
  },
  data() {
    return {
      show: false,
      showse: false,
      showses: false,
      showsesr: false,
      areaList,
      minDate: new Date(1970, 1, 1),
      maxDate: new Date(2038, 11, 31),
      shows: false,
      showArea: false,
      gather: {
        merchant_business_type: "1", //客户服务主体类型
        account_type: "1", //财户类型
        settlement_type: "1", //结算类型
        license_type: "0", //营业证件类型
        license_no: "", //营业证件号码
        license_expire: "", //营业证件到期日GoodsHouseholdType
        artif_nm: "", //法人姓名
        legalIdnum: "", //法人身份证
        legalIdnumExpire: "", //法人身份证到期
        merchant_id_no: "", //结算人身份证号码
        merchant_id_expire: "", //结算人身份证到期
        account_name: "", //	入账银行开户号
        account_no: "", //入账银行开户卡号
        account_phone: "", //入账银行预留手机号
        bank_name: "", //入账银行卡开户支行
        bank_no: "", //入账银行卡开户支行联行号
        settle_type: "", //清算类型 1：自动结算，2：手动结算
        img_license: "", //营业执照
        img_idcard_a: "", //法人身份证正面
        img_idcard_b: "", //法人身份证反面
        img_private_idcard_a: "", //对私账户身份证正面照片
        img_private_idcard_b: "", //对私账户身份证反面照片
        img_bankcard_a: "", //入账银行卡正面照片
        img_bankcard_b: "", //入账银行卡反面照片
        img_logo: "", //商户门头照片
        img_indoor: "", //门脸(内设)照片(前台)
        img_contract: "", //店内环境照片
        img_other: "", //其他证明材料
        img_idcard_holding: "", //本人手持身份证照片
        img_open_permits: "", //开户许可证照片
        img_org_code: "", //组织机构代码证照片
        img_tax_reg: "", //税务登记证照片
        img_unincorporated: "" //入账非法人证明照片
      }
    };
  },
  watch: {
    // "gather.GoodsHouseholdType": {
    //   deep: true,
    //   handler: function(val) {}
    // }
  },
  methods: {
    identityZ(data) {
      //法人身份证正面
      this.gather.img_idcard_a = data;
      console.log(this.gather.img_idcard_a, "法人身份证正面");
    },
    identityY(data) {
      //法人身份证反面
      this.gather.img_idcard_b = data;
      console.log(this.gather.img_idcard_b, "法人身份证反面");
    },
    img_bankcard_a(data) {
      //入账银行卡正面照片
      this.gather.img_bankcard_a = data;
      console.log(this.gather.img_bankcard_a, "入账银行卡正面照片");
    },
    img_bankcard_b(data) {
      //入账银行卡反面照片
      this.gather.img_bankcard_b = data;
      console.log(this.gather.img_bankcard_b, "入账银行卡反面照片");
    },
    img_private_idcard_a(data) {
      //对私账户身份证正面照片
      this.gather.img_private_idcard_a = data;
      console.log(this.gather.img_private_idcard_a, "对私账户身份证正面照片");
    },
    img_private_idcard_b(data) {
      //对私账户身份证反面照片
      this.gather.img_private_idcard_b = data;
      console.log(this.gather.img_private_idcard_b, "对私账户身份证反面照片");
    },
    img_logo(data) {
      //商户门头照片
      this.gather.img_logo = data;
      console.log(this.gather.img_logo, "商户门头照片");
    },
    img_indoor(data) {
      //门脸(内设)照片(前台)
      this.gather.img_indoor = data;
      console.log(this.gather.img_indoor, "门脸(内设)照片(前台)");
    },
    img_contract(data) {
      //店内环境照片
      this.gather.img_contract = data;
      console.log(this.gather.img_contract, "店内环境照片");
    },

    img_other(data) {
      //其他证明材料
      this.gather.img_other = data;
      console.log(this.gather.img_other, "其他证明材料");
    },
    img_idcard_holding(data) {
      //本人手持身份证照片
      this.gather.img_idcard_holding = data;
      console.log(this.gather.img_idcard_holding, "本人手持身份证照片");
    },
    img_open_permits(data) {
      //开户许可证照片
      this.gather.img_open_permits = data;
      console.log(this.gather.img_open_permits, "开户许可证照片");
    },
    img_org_code(data) {
      //组织机构代码证照片
      this.gather.img_org_code = data;
      console.log(this.gather.img_org_code, "组织机构代码证照片");
    },
    img_tax_reg(data) {
      //税务登记证照片
      this.gather.img_tax_reg = data;
      console.log(this.gather.img_tax_reg, "税务登记证照片");
    },

    img_unincorporated(data) {
      //入账非法人证明照片
      this.gather.img_unincorporated = data;
      console.log(this.gather.img_unincorporated, "入账非法人证明照片");
    },
    business(data) {
      //营业执照
      this.gather.img_license = data;
      console.log(this.gather.img_license, "营业执照");
    },

    onConfirms(values) {
      this.gather.value = values.map(item => item.name).join("/");
      this.showArea = false;
    },
    formatDate(date) {
      return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;
    },
    onConfirm(date) {
      this.show = false;
      this.gather.license_expire = this.formatDate(date);
    },
    onConfirma(date) {
      this.showse = false;
      this.gather.legalIdnumExpire = this.formatDate(date);
    },
    onConfirmas(date) {
      this.showses = false;
      this.gather.merchant_id_expire = this.formatDate(date);
    },
    onConfirmasr(date) {
      this.showsesr = false;
      this.gather.bank_name = this.formatDate(date);
    },
    newdate() {
      var datetime = new Date();
      var year = datetime.getFullYear();
      var month =
        datetime.getMonth() + 1 < 10
          ? "0" + (datetime.getMonth() + 1)
          : datetime.getMonth() + 1;
      var date =
        datetime.getDate() < 10 ? "0" + datetime.getDate() : datetime.getDate();
      this.gather.license_expire = `${year}/${month}/${date}`;
      this.gather.legalIdnumExpire = `${year}/${month}/${date}`;
      this.gather.merchant_id_expire = `${year}/${month}/${date}`;
      this.gather.bank_name = `${year}/${month}/${date}`;
    },

    nextstep() {
      if (!this.gather.BusinessDocumentNumber.trim()) {
        Toast("营业证件号码不能为空");
        return;
      }
      if (!this.gather.dateDue) {
        Toast("营业证件到期日不能为空");
        return;
      }
      if (!this.gather.legalPerson) {
        Toast("法人姓名不能为空");
        return;
      }
      if (!this.gather.CorporateIdentityCard) {
        Toast("法人身份证不能为空");
        return;
      }
      if (this.gather.checked == false) {
        if (!this.gather.IdcardExpires) {
          Toast("法人身份证到期不能为空");
          return;
        }
      }
      console.log(this.gather);
    }
  },

  mounted() {
    this.newdate();
  }
};
</script>
<style lang="scss" scoped>
.home {
  width: 100%;
  background: rgba(246, 247, 249, 1);
  .home-perspmal-van-cell {
    overflow: hidden;
    background-color: #fff;
    padding: 1.25rem 0.6875rem 1.25rem 0.6875rem;

    .home-perspmal-van-cell__title {
      float: left;
      span {
        font-size: 1rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(34, 34, 34, 1);
      }
    }
    .home-perspmal-van-cell__value {
      float: right;
      .van-cell::after {
        border-bottom: 0px;
      }
      .van-cell {
        padding: 0;
      }
      input {
        border: 0;
      }
      span {
        font-size: 1rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(198, 198, 198, 1);
      }
    }
    .home-perspmal-van-cell__values {
      width: 100%;
      padding-top: 1.34375rem;
      display: flex;
      div {
        width: 100%;
        div {
          margin: 0;
          flex: 1;
        }
        div:first-child {
          justify-content: flex-start;
        }
        div:nth-child(2) {
          justify-content: center;
        }
        div:last-child {
          justify-content: flex-end;
        }
      }
    }
    .home-perspmal-van-cell__val {
      display: flex;
    }
  }

  /deep/.home-perspmal-van-cell__value span[data-v-3dce2c05] {
    font-size: 0.81875rem;
    font-family: PingFangSC-Regular, PingFang SC;
    color: #323233;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  /deep/.van-cell__title {
    font-size: 1rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(34, 34, 34, 1);
  }
  .uploader-business {
    padding: 1.25rem 0.6875rem;
    /deep/.van-uploader__upload,
    /deep/.van-uploader__preview-image {
      width: 4.65625rem;
      height: 8.28125rem;
      background: rgba(242, 242, 242, 1);
    }
    /deep/.van-field__control--custom {
      align-items: flex-end;
      justify-content: flex-end;
    }
  }
  .uploader-identity {
    padding: 1.25rem 0.6875rem;
    display: block;
    /deep/.van-field__label {
      width: 100%;
      height: fit-content;
      padding-bottom: 1.25rem;
    }
    /deep/.van-uploader {
      width: 9.375rem;
      height: 6.25rem;
    }
    /deep/ .van-uploader__upload {
      width: 9.375rem;
      height: 6.25rem;
    }
    /deep/.van-field__control {
      justify-content: center;
      align-items: center;
      .van-uploader__preview-image {
        width: 9.375rem;
        height: 6.25rem;
      }
    }
    /deep/.van-uploader:first-child {
      margin-right: 1.25rem;
      // margin-right: 2.5rem;
      .van-uploader__upload {
        background: url("../../assets/image/Merch.jpg");
        background-size: 100% 100%;
      }
    }
    /deep/.van-uploader:last-child {
      .van-uploader__upload {
        background: url("../../assets/image/Merchs.jpg");
        background-size: 100% 100%;
      }
    }
  }
  .uploader-bankCard {
    padding: 1.25rem 0.6875rem;
    display: block;
    /deep/.van-field__label {
      width: 100%;
      height: fit-content;
      padding-bottom: 1.25rem;
    }
    /deep/.van-uploader {
      width: 9.375rem;
      height: 6.25rem;
    }
    /deep/ .van-uploader__upload {
      width: 9.375rem;
      height: 6.25rem;
    }
    /deep/.van-field__control {
      justify-content: center;
      align-items: center;
      .van-uploader__preview-image {
        width: 9.375rem;
        height: 6.25rem;
      }
    }
    /deep/.van-uploader:first-child {
      margin-right: 1.25rem;
      // margin-right: 2.5rem;
    }
  }

  .home-perspmal-MerchantEntrancePhoto {
    display: block;
    /deep/.van-uploader__preview {
      margin: 0 0.3rem 0.25rem 0;
    }
    /deep/.van-uploader__preview-image {
      width: 4.7rem;
      height: 4.7rem;
    }
    /deep/.van-field__label {
      width: 100%;
      height: fit-content;
      padding-bottom: 1.25rem;
    }
    /deep/.van-uploader__upload {
      width: 4.7rem;
      height: 4.7rem;
    }
  }
  /deep/.van-icon-success::before {
    content: "";
  }
  /deep/.van-checkbox__icon--checked .van-icon,
  /deep/.van-radio__icon--checked .van-icon {
    color: #fff;
    background-color: #fff;
    border: 0.4rem solid #1980fa;
  }
  /deep/.van-cell--required::before {
    content: " ";
  }
  /deep/.van-field__control {
    text-align: right;
  }
  .home-cell__value-buttom {
    width: 100%;
    position: relative;
    box-sizing: border-box;
    padding: 0.75rem;
    overflow: hidden;
  }
  .home-pmal-Photo {
    /deep/.van-field__label {
      flex: 1.5;
    }
    /deep/.van-field__control--custom {
      justify-content: flex-end;
    }
  }
}
</style>
